import dayjs from "dayjs";

/* ─── Static lead list data ─── */
export const storageLeadList = [
  {
    generated_id: "STR-001",
    customer_name: "James Harrison",
    status: "STORAGE_ENQUIRY",
    follow_up_date: dayjs().add(3, "day").toISOString(),
    created_at: dayjs().subtract(2, "day").toISOString(),
    moving_on_date: dayjs().add(14, "day").toISOString(),
    updated_at: dayjs().subtract(1, "day").toISOString(),
    customer_phone: "+44 7700 900123",
    customer_email: "james.harrison@email.com",
  },
  {
    generated_id: "STR-002",
    customer_name: "Sarah Mitchell",
    status: "STORAGE_ENQUIRY",
    follow_up_date: dayjs().add(1, "day").toISOString(),
    created_at: dayjs().subtract(5, "day").toISOString(),
    moving_on_date: dayjs().add(21, "day").toISOString(),
    updated_at: dayjs().toISOString(),
    customer_phone: "+44 7700 900456",
    customer_email: "sarah.m@email.com",
  },
  {
    generated_id: "STR-003",
    customer_name: "David Chen",
    status: "STORAGE",
    follow_up_date: dayjs().add(5, "day").toISOString(),
    created_at: dayjs().subtract(8, "day").toISOString(),
    moving_on_date: dayjs().add(30, "day").toISOString(),
    updated_at: dayjs().subtract(2, "day").toISOString(),
    customer_phone: "+44 7700 900789",
    customer_email: "david.chen@email.com",
  },
  {
    generated_id: "STR-004",
    customer_name: "Emily Roberts",
    status: "STORAGE",
    follow_up_date: null,
    created_at: dayjs().subtract(10, "day").toISOString(),
    moving_on_date: dayjs().add(7, "day").toISOString(),
    updated_at: dayjs().subtract(1, "day").toISOString(),
    customer_phone: "+44 7700 900321",
    customer_email: "emily.r@email.com",
  },
  {
    generated_id: "STR-005",
    customer_name: "Michael Taylor",
    status: "COMPLETE",
    follow_up_date: dayjs().add(2, "day").toISOString(),
    created_at: dayjs().subtract(15, "day").toISOString(),
    moving_on_date: dayjs().add(5, "day").toISOString(),
    updated_at: dayjs().toISOString(),
    customer_phone: "+44 7700 900654",
    customer_email: "michael.t@email.com",
  },
];

/* ─── Build full lead detail for a given lead id ─── */
export const getStorageLeadDetail = (generatedId: string | null) => {
  const lead = storageLeadList.find((l) => l.generated_id === generatedId);
  if (!lead) return null;

  return {
    lead: {
      ...lead,
      survey_id: null,
      survey_status: null,
      packing_on_date: dayjs().add(10, "day").toISOString(),
      moving_on_end_date: null,
      customer_notes:
        "Customer requires temperature-controlled storage unit for furniture and personal items. Access needed on weekends.",
      collection_address: [
        {
          building_number: "42",
          street: "High Street",
          town: "Manchester",
          county: "Greater Manchester",
          postcode: "M1 4BE",
          country: "UK",
          purchaseStatus: "Owned",
          houseSize: "3 Bedroom",
          distance: 12.5,
          volume: 28.0,
          volumeUnit: "m3",
        },
      ],
      delivery_address: [
        {
          building_number: "Unit 7",
          street: "Storage Park Way",
          town: "Salford",
          county: "Greater Manchester",
          postcode: "M5 3EJ",
          country: "UK",
          purchaseStatus: "Rented",
          houseSize: "N/A",
          distance: 5.2,
          volume: 28.0,
          volumeUnit: "m3",
        },
      ],
      returning_distance: "17.7",
    },
    referrer: {
      name: "Storage Solutions Ltd",
      contact_name: "Tom Baker",
      email: "info@storagesolutions.co.uk",
    },
  };
};

/* ─── Static log entries ─── */
export const getStorageLogs = (generatedId: string | null) => {
  if (!generatedId) return [];
  return [
    {
      actor_name: "Admin",
      created_at: dayjs().subtract(1, "hour").toISOString(),
      action: "Storage enquiry created",
    },
    {
      actor_name: "Admin",
      created_at: dayjs().subtract(3, "hour").toISOString(),
      action: "Estimate sent to customer",
    },
    {
      actor_name: "System",
      created_at: dayjs().subtract(1, "day").toISOString(),
      action: "Follow-up reminder scheduled",
    },
    {
      actor_name: "Admin",
      created_at: dayjs().subtract(2, "day").toISOString(),
      action: "Customer contacted via phone",
    },
  ];
};
